import { keyframes } from '@mui/material/styles'
import { skeletonOpacity } from '@/styles/designTokens'

/**
 * Shared skeleton pulse animation — used by CategoryNavSkeleton and MenuSkeleton.
 * Opacity values come from skeletonOpacity tokens in designTokens.ts.
 */
export const skeletonPulse = keyframes`
  0%, 100% { opacity: ${skeletonOpacity.high}; }
  50% { opacity: ${skeletonOpacity.mid}; }
`
